import { CheckIcon, InfoIcon, SmallCloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Heading,
  SimpleGrid,
  Spinner,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import API from "../../api";
import OverviewFilter from "../../components/overviewFilter";
import { APP_NAMES } from "../../constants/index";
import { useAppContext } from "../../context/index";
import logger from "../../utils/logger";

export default function Overview() {
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const { partner, setPartner, fetchPartner } = useAppContext();
  const [tableData, setTableData] = useState([]);
  const [partnerData, setPartnerData] = useState([]);

  const fetchOverviewData = async ({
    from = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)),
    to = new Date(new Date(Date.now()).setHours(23, 59, 59, 999)),
    appEnabled = false,
    partnerEnabled = false,
  }) => {
    try {
      console.log("get data", from, to, appEnabled, partnerEnabled);
      setLoading(true);

      await API(
        "/analytics/get-analytics?" +
          new URLSearchParams({
            from,
            to,
            appEnabled,
            partnerEnabled,
          }),
        "GET"
      )
        .then((data) => {
          if (data) {
            console.log(data);
            setTableData(data?.tableData);
            setPartnerData(data);
          }
        })
        .catch((err) => {
          toast({
            title: "Error in fetching data!",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log("error", err);
        });
      setLoading(false);
    } catch (error) {
      logger({
        functionName: "OverView Anlytics Data.initializeAnalyticsData",
        error,
        sentry: true,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOverviewData({});
  }, []);

  const onApply = async (data) => {
    await fetchOverviewData({ ...data });
  };

  return (
    <>
      {" "}
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "20px -20px",
        }}
      >
        <OverviewFilter onApply={onApply} />
      </div>
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "20px -20px",
        }}
      >
        <SimpleGrid
          spacing={4}
          templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
        >
          <Card>
            <CardHeader>
              <Heading size="md"> Projected Earnings</Heading>
            </CardHeader>
            <CardBody>
              <Text>Amount : ₹{partnerData?.projectedEarnings}</Text>
              <p>(Approx)</p>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Heading size="md"> Total Earnings</Heading>
            </CardHeader>
            <CardBody>
              <Text>Amount : ₹{partnerData?.totalEarnings}</Text>
              <p>(Approx)</p>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Heading size="md"> Total Stores</Heading>
            </CardHeader>
            <CardBody>
              <Text>Number of Stores :{partnerData?.totalNoOfStores}</Text>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Heading size="md"> Active Stores</Heading>
            </CardHeader>
            <CardBody>
              <Text>
                Number of Stores :{partnerData?.totalNoOfActiveStores}
              </Text>
            </CardBody>
          </Card>
        </SimpleGrid>
      </div>
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "0px -20px",
        }}
      >
        {" "}
        {loading ? (
          <Center bg="white" h="100px">
            <Spinner />
          </Center>
        ) : (
          <Box>
            <TableContainer>
              <Table variant="striped" colorScheme="gray">
                <TableCaption>
                  Please Go to Settings to Generate the token and integrate it
                  on Codfirm to see your earned commision.
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>S No.</Th>
                    <Th>Store Url</Th>
                    <Th>App Name</Th>
                    <Th isNumeric>Projected Earnings (₹)</Th>
                    <Th isNumeric>
                      Total Earnings (₹){"  "}
                      <Tooltip label="Earnings that are setteled completely.">
                        <InfoIcon />
                      </Tooltip>
                    </Th>
                    <Th>
                      Eligible for Payout{"  "}
                      <Tooltip label="Store should be active on app for more than 3 months.">
                        <InfoIcon />
                      </Tooltip>
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {tableData?.length ? (
                    tableData.map((row, index) => {
                      return (
                        <Tr>
                          <Td>{index + 1}</Td>
                          <Td>
                            <a href={"https://" + row?.storeUrl}>
                              {row?.storeUrl}
                            </a>
                          </Td>
                          <Td>{APP_NAMES[row?.appName]}</Td>
                          <Td>₹{row?.projectedEarnings}</Td>
                          <Td>₹{row?.totalEarnings}</Td>
                          <Td>
                            {row?.eligibleForPayout ? (
                              <CheckIcon />
                            ) : (
                              <SmallCloseIcon />
                            )}
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <>No data found</>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </div>
    </>
  );
}
